import React, { useState, useEffect, useContext } from "react";
import { Container, Fab, Button, IconButton, Snackbar } from "@mui/material";
import { withStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import WindowTitleComponent from "../WindowTitleComponent";
import { SettingsContext } from "../Settings";
import EditPostComponent from "./EditPostComponent";
import PostCard from "./PostCard";
import CommentsComponent from "./CommentsComponent";

const PAGE_SIZE = 16;

const styles = () => ({
  container: {
    maxWidth: "780px",
  },
});

const De37Component = ({
  classes,
  user,
  Parse,
  cardId,
  routeProps,
  postEvent,
  removePostEvent,
  events,
}) => {
  const [currentPage, setPage] = useState(0);
  const [postList, setPostList] = useState([]);
  const [open, setOpen] = useState(!!postEvent);
  const [extraKey, setExtraKey] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [editPost, setEditPost] = useState(null);

  const handleSnackbarClose = () => {
    setErrorMessage(null);
  };

  useEffect(() => {
    let query = new Parse.Query(Parse.Object.extend("Post"));
    query.descending("createdAt");
    query.limit(PAGE_SIZE);
    query.skip(currentPage * PAGE_SIZE);

    query.find().then((results) => {
      setPostList(postList.concat(results));

      // We only add a subscription for the first page
      if (currentPage !== 0) return;
      query.subscribe().then((subscription) => {
        subscription.on("create", (object) => {
          if (!postList.some((i) => i.id === object.id)) {
            setPostList((currentPostList) => [object, ...currentPostList]);
          }
        });

        subscription.on("update", (object) => {
          setPostList((currentPostList) =>
            currentPostList.map((item) =>
              item.id === object.id ? object : item,
            ),
          );
        });

        subscription.on("delete", (object) => {
          setPostList((currentPostList) =>
            currentPostList.filter((item) => item.id !== object.id),
          );
        });
      });
    });
  }, [currentPage]);

  const nextPage = () => setPage(currentPage + 1);

  const closeEdit = () => {
    removePostEvent();
    setOpen(false);
    setEditPost(null);
    setExtraKey(!extraKey);
  };

  const handleAddPostClick = () => {
    setOpen(true);
  };

  const context = useContext(SettingsContext);

  return (
    <Container className={classes.container}>
      <WindowTitleComponent title="De 37" />

      {context.isAdmin || context.isCommissielid ? (
        <Fab
          color="primary"
          aria-label="Add"
          onClick={handleAddPostClick}
          className="add-fab"
        >
          <AddIcon />
        </Fab>
      ) : null}

      {/* De nieuwe key wordt beneden gebruikt om de component te resetten */}
      <EditPostComponent
        dialog
        open={open}
        onClose={closeEdit}
        upload={(result, msg) => {
          if (result) {
            closeEdit();
          } else {
            setErrorMessage(msg);
          }
        }}
        events={events}
        post={editPost}
        key={editPost ? editPost.objectId : extraKey}
        postEvent={postEvent}
      />

      <div className="flex-column">
        {postList.map((i) => {
          let post = i.toJSON();
          post.parse = i;
          if (post.test && !context.showTestContent) return null;
          if (cardId === undefined || post.objectId === cardId) {
            return (
              <PostCard
                user={user}
                key={post.objectId}
                routeProps={routeProps}
                edit={(post) => {
                  setEditPost(post);
                  setOpen(true);
                  requestAnimationFrame(() => window.scrollTo(0, 0));
                }}
                post={post}
                commentsPreview={cardId === undefined}
              />
            );
          } else {
            return null;
          }
        })}
        {cardId !== undefined ? (
          <>
            <h3>Reacties</h3>
            <CommentsComponent parentId={cardId} parentType="Post" />
          </>
        ) : (
          <Button
            id="load-more-posts-button"
            variant="contained"
            color="primary"
            onClick={nextPage}
          >
            Laad meer posts
          </Button>
        )}
        {/* The following CSS hides the 'Load more posts' button when the app is loading the first posts */}
        <style>{`
          #load-more-posts-button:first-child {
            display: none;
          }
        `}</style>
      </div>

      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={errorMessage}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        ContentProps={{
          "aria-describedby": "message-id",
        }}
        message={<span id="message-id">{errorMessage}</span>}
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            style={{ padding: "4px" }}
            onClick={handleSnackbarClose}
            size="large"
          >
            <CloseIcon />
          </IconButton>,
        ]}
      />
    </Container>
  );
};

// De37Component.contextType = SettingsContext;
export default withStyles(styles)(De37Component);
